import React from 'react';
import { Box, Flex, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface IOTPParametersSummaryBarProps {
    originalMME: number;
    targetFinalMME: number;
    reductionPercentage: number;
    daysPerStep: number;
    totalDurationDays?: number;
    drugLabel?: string;
}

export const OTPParametersSummaryBar: React.FC<IOTPParametersSummaryBarProps> = ({
    originalMME,
    targetFinalMME,
    reductionPercentage,
    daysPerStep,
    totalDurationDays,
    drugLabel,
}) => {
    const { t } = useTranslation();

    return (
        <Box style={{ border: '1px solid #e0e0e0', borderRadius: 4 }}>
            <Flex p="md" style={{ backgroundColor: '#f9f9f9', borderRadius: 4 }}>
                <Flex gap="xl" align="center" wrap="wrap" style={{ flex: 1 }}>
                    <Title order={5}>
                        {t('otp.parameters.title', 'OTP Parameters')}
                    </Title>
                    <Box style={{ width: 1, height: 24, backgroundColor: '#d0d0d0' }} />
                    <Box>
                        <Text size="xs" fw={600} c="dimmed" tt="uppercase">
                            {t('otp.parameters.originalMME', 'Starting')}
                        </Text>
                        <Text size="sm" fw={600}>
                            {originalMME} MME
                        </Text>
                    </Box>
                    <Box>
                        <Text size="xs" fw={600} c="dimmed" tt="uppercase">
                            {t('otp.parameters.targetFinalMME', 'Target')}
                        </Text>
                        <Text size="sm" fw={600}>
                            {targetFinalMME} MME
                        </Text>
                    </Box>
                    <Box>
                        <Text size="xs" fw={600} c="dimmed" tt="uppercase">
                            {t('otp.parameters.reductionPercentage', 'Reduction')}
                        </Text>
                        <Text size="sm" fw={600}>
                            {reductionPercentage}% / {daysPerStep} {t('otp.parameters.days', 'days')}
                        </Text>
                    </Box>
                    {totalDurationDays !== undefined && (
                        <Box>
                            <Text size="xs" fw={600} c="dimmed" tt="uppercase">
                                {t('otp.parameters.duration', 'Duration')}
                            </Text>
                            <Text size="sm" fw={600}>
                                {totalDurationDays} {t('otp.parameters.days', 'days')}
                            </Text>
                        </Box>
                    )}
                    {drugLabel && (
                        <Box>
                            <Text size="xs" fw={600} c="dimmed" tt="uppercase">
                                {t('otp.parameters.drug', 'Drug')}
                            </Text>
                            <Text size="sm" fw={600}>
                                {drugLabel}
                            </Text>
                        </Box>
                    )}
                </Flex>
            </Flex>
        </Box>
    );
};
